import React from 'react';
import ReactDOM from 'react-dom';
import QR from 'qrcode.react';
import { connect } from 'react-redux';

import Artwork from '../FullScreenCarouselItem';
import SelectedPlaylistCarousel from '../SelectedPlaylistCarousel';
import Account from '../Account';
import Settings from '../Settings';

import SoundCloudPlayer from '../SoundCloudPlayer';
import SoundCloudButton from '../SoundCloudButton';
import { FETCH_MOBILE_STATUS_FAILURE } from '../../store/constants/mobileConstants';
import './freemium-full-screen-carousel.scss';
import { fireAnalytics } from '../../pages/utils';
import { fetchActivePlaylist } from '../../store/actions/playlistActions';
import { fetchMobileQueue, fetchMobileStatus } from '../../store/actions/mobileActions';
import { pauseSoundCloudStream, resumeSoundCloudStream } from '../../store/actions/soundCloudActions';
import { set4kQuality, setMute, setQR, setShowArtworkDetails, setSwitchArtwork, setShowLogo } from '../../store/actions/settingActions';
import { ENTER, BACK, LEFT, UP, RIGHT, DOWN, EXIT } from '../../util/remoteButtons';
import bdReq from '../../../@packages/@bd-uikit-web/js-helpers/bdReq';

export class FreemiumCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: props.selectedArtwork,
      navTimeout: null,
      navigating: false,
      showNav: false,
      nxtLoad: false,
      others: false,
      artworks: props.artworks,
      show: true,
      activeComponent: false,
      currentPlaylist: 0,
      selectedPlaylistId: props.selectedPlaylistId,
      selectedPlaylist: null,
      open: false,
      lastMobileUpdate: null,
      selectedButton: 'view',
      artworkError: false,
      clearCache: false,
      hideCollection: true,
      selectedMenu: 'account',
      openMenu: false,
      openAccount: false,
      openSettings: false,
      hideDetails: this.props.setting.showArtworkDetails,
      qr: this.props.setting.qr,
      quality: this.props.setting.highQuality,
      mute: this.props.setting.mute,
      logo: this.props.setting.logo,
    };
    this.fsTimeout = null;
    this.getCurrentArtworkArtistName = this.getCurrentArtworkArtistName.bind(this);
    this.getCurrentArtworkName = this.getCurrentArtworkName.bind(this);
    this.handleConnectionChange = this.handleConnectionChange.bind(this);
    this.setArtworkInterval = this.setArtworkInterval.bind(this);
    this.addOrientationClassToBody = this.addOrientationClassToBody.bind(this);
    this.addOrientationClassToPlaylistCarousel = this.addOrientationClassToPlaylistCarousel.bind(this);
    this.hideCollections = this.hideCollections.bind(this);
    this.k = 1;
    this.artworkInterval = 300000;
    this.updatePlaylist = true;
    this.hideArtworkNameTimeout = null;
    this.selectedBtn = 'No';
    this.onlineStatusInterval = null;
    this.artworkIntervalTime = null;
    this.artworkErrorMessage = '';
    this.onlineStatusTimer = 0;
    this.prevPlaylistId = '';
    this.fetchMobilePlaylistInterval = null;
  }

  componentDidMount() {
    fireAnalytics('Page', 'Player Page Loaded');
    window.onkeydown = (e) => {
      if (navigator.onLine) {
        if (this.state.navigating) {
          switch (e.keyCode) {
            case ENTER: {
              if (this.state.open) {
                if (this.selectedBtn === 'No') {
                  this.setState({ open: false });
                  setTimeout(() => {
                    var mainDiv = this.refs.mainDiv;
                    mainDiv.focus();
                  }, 700);
                }
                if (this.selectedBtn === 'Yes') {
                  window.open('', '_self').close();
                }
              } else if (this.state.clearCache) {
                if (this.selectedBtn === 'No') {
                  this.setState({ clearCache: false });
                  setTimeout(() => {
                    var mainDiv = this.refs.mainDiv;
                    mainDiv.focus();
                  }, 700);
                }
                if (this.selectedBtn === 'Yes') {
                  this.removeAllDownloads();
                }
              } else {
                switch (this.state.selectedButton) {
                  case 'account': {
                    this.props.history.push('/Account');
                    break;
                  }
                  case 'upgrade': {
                    localStorage.setItem(
                      'playlistID',
                      'Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx'
                    );
                    this.props.history.push('/Pair');
                    break;
                  }
                  default:
                    this.setState((prevState) => ({ ...prevState, navigating: false, navTimeout: null }));
                    break;
                }
              }
              break;
            }
            case LEFT: {
              if (this.state.open || this.state.clearCache) {
                document.getElementById('yes').style.background = '';
                document.getElementById('No').style.background = '#910048';
                this.refs.no.focus();
                this.selectedBtn = 'No';
              } else {
                clearTimeout(this.state.navTimeout);
                if (!this.state.activeComponent) {
                  this.prevHandle();
                }
              }

              break;
            }
            case RIGHT: {
              if (this.state.open || this.state.clearCache) {
                document.getElementById('No').style.background = '';
                document.getElementById('yes').style.background = '#910048';
                this.refs.yes.focus();
                this.selectedBtn = 'Yes';
              } else {
                clearTimeout(this.state.navTimeout);
                if (!this.state.activeComponent) {
                  this.nextHandle();
                }
              }
              break;
            }
            case UP: {
              if (!this.state.open) {
                clearTimeout(this.state.navTimeout);
                const navTimeout = setTimeout(() => {
                  this.setState((prevState) => ({ ...prevState, navigating: false }));
                }, 400000);

                if (this.props.hasSubscription) {
                  this.setState((prevState) => ({ ...prevState, selectedButton: 'account', navTimeout }));
                  setTimeout(() => {
                    const { accountButton } = this.refs;
                    accountButton.focus();
                  }, 300);
                } else {
                  this.setState((prevState) => ({ ...prevState, selectedButton: 'upgrade', navTimeout }));
                  setTimeout(() => {
                    const { upgrade } = this.refs;
                    upgrade.focus();
                  }, 300);
                }
                break;
              }
            }
            case 27:
              this.setState({ clearCache: !this.state.clearCache });
              break;
            case BACK: {
              setTimeout(() => {
                var no = this.refs.no;
                no.focus();
              }, 200);
              this.setState({ open: !this.state.open });
              break;
            }
            default:
              break;
          }
        } else if (
          (e.keyCode === LEFT || e.keyCode === RIGHT || e.keyCode === UP) &&
          !this.state.activeComponent &&
          !this.state.openAccount &&
          !this.state.openSettings
        ) {
          if (this.state.hideCollection && !this.state.activeComponent && !this.state.openMenu && e.keyCode === UP) {
            this.setState({
              openMenu: true,
            });
          } else if (e.keyCode === UP && this.state.openMenu) {
            this.setState({
              openMenu: false,
            });
          } else if (
            this.state.openMenu &&
            e.keyCode === LEFT &&
            (this.state.selectedMenu === 'settings' || this.state.selectedMenu === 'account')
          ) {
            this.setState({
              selectedMenu: 'account',
            });
          } else if (
            this.state.openMenu &&
            e.keyCode === RIGHT &&
            (this.state.selectedMenu === 'account' || this.state.selectedMenu === 'settings')
          ) {
            this.setState({
              selectedMenu: 'settings',
            });
          } else if (this.state.open && e.keyCode === LEFT) {
            document.getElementById('yes').style.background = '';
            document.getElementById('No').style.background = '#910048';
            this.refs.no.focus();
            this.selectedBtn = 'No';
          } else if (this.state.open && e.keyCode === RIGHT) {
            document.getElementById('No').style.background = '';
            document.getElementById('yes').style.background = '#910048';
            this.refs.yes.focus();
            this.selectedBtn = 'Yes';
          } else {
            clearTimeout(this.state.navTimeout);
            const navTimeout = setTimeout(() => {
              this.setState((prevState) => ({ ...prevState, navigating: false }));
            }, 4000);
            this.setState((prevState) => ({ ...prevState, navigating: true, navTimeout }));
          }
        } else if (e.keyCode === DOWN && !this.state.openSettings) {
          if (!this.state.open && !this.state.openMenu) {
            if (this.state.activeComponent) {
            } else {
              this.setState(() => ({ activeComponent: true, hideCollection: false }));
              this.addOrientationClassToPlaylistCarousel();
              setTimeout(() => {
                const { playlistChild } = this.refs;
                playlistChild.refs.carousel.focus();
              }, 300);
            }
          } else if (this.state.openMenu) {
            this.setState({
              openMenu: false,
            });
          }
        } else if (e.keyCode === BACK) {
          if (this.state.activeComponent) {
            this.setState(() => ({ activeComponent: false }));
          } else {
            setTimeout(() => {
              this.setState({ open: !this.state.open });
              var no = this.refs.no;
              no.focus();
            }, 700);
          }
        } else if (e.keyCode === 405) {
          setTimeout(() => {
            var no = this.refs.no;
            no.focus();
          }, 200);
          this.setState({ clearCache: !this.state.clearCache });
        } else if (e.keyCode === ENTER) {
          if (this.state.open) {
            if (this.selectedBtn === 'No') {
              this.setState({ open: false });
              setTimeout(() => {
                var mainDiv = this.refs.mainDiv;
                mainDiv.focus();
              }, 700);
            }
            if (this.selectedBtn === 'Yes') {
              window.open('', '_self').close();
            }
          } else if (this.state.clearCache) {
            if (this.selectedBtn === 'No') {
              this.setState({ clearCache: false });
              setTimeout(() => {
                var mainDiv = this.refs.mainDiv;
                mainDiv.focus();
              }, 700);
            }
            if (this.selectedBtn === 'Yes') {
              this.removeAllDownloads();
            }
          } else if (this.state.openMenu) {
            if (this.state.selectedMenu === 'account') {
              this.setState({
                openAccount: true,
              });
            } else if (this.state.selectedMenu === 'settings') {
              this.setState({
                openSettings: true,
              });
            }
          }
        } else if (e.keyCode === UP) {
          if (this.state.hideCollection) {
            this.setState({
              activeComponent: false,
            });
          }
        }
      } else {
        this.artworkErrorMessage = 'No Internet Connection';
        this.setState({ artworkError: true });
        setTimeout(() => {
          this.setState({ artworkError: false });
        }, 3000);
      }
    };
    this.addOrientationClassToBody();
    if (this.props.hasSubscription) {
      this.fetchMobilePlaylistInterval = setInterval(() => this.FetchFromMobile(), 5000);
    } else {
      this.fetchMobilePlaylistInterval = 10;
      this.setArtworkInterval(this.artworkInterval);
    }
    window.addEventListener('online', this.handleConnectionChange);
    window.addEventListener('offline', this.handleConnectionChange);

    if (!this.props.setting.showArtworkDetails) {
      this.setState({
        hideDetails: true,
      });
    } else {
      this.setState({
        hideDetails: false,
      });
    }
  }

  removeAllDownloads() {
    const that = this;
    var successCb = function (cbObject) {
      that.setState({ clearCache: false });
      that.props.history.push('/');
    };

    var failureCb = function (cbObject) {
      var errorCode = cbObject.errorCode;
      var errorText = cbObject.errorText;
    };

    var options = {
      device: 'internal', // This will remove all the files in the local storage.
    };

    var storage = new Storage();
    storage.removeAll(successCb, failureCb, options);
  }

  addOrientationClassToBody() {
    if (window.innerWidth <= window.innerHeight) {
      if (document.getElementsByClassName('PlaylistSelector')[0] !== undefined) {
        document.getElementsByClassName('PlaylistSelector')[0].classList.add('PlaylistSelector_Rotated');
      }
    }
  }

  addOrientationClassToPlaylistCarousel() {
    if (window.innerWidth <= window.innerHeight) {
      if (document.getElementsByClassName('PlaylistSelector')[0] !== undefined) {
        document.getElementsByClassName('PlaylistSelector')[0].classList.add('PlaylistSelector_Rotated');
      }
    }
  }

  handleConnectionChange(event) {
    if (event.type == "offline") {
      fireAnalytics("Network", "Connection Offline");
      clearInterval(this.artworkIntervalTime);
      clearInterval(this.fetchMobilePlaylistInterval);
      this.artworkErrorMessage = "No Internet Connection";
      this.setState({ artworkError: true });
      setTimeout(() => {
        this.setState({ artworkError: false });
      }, 3000);
    }
    if (event.type == "online") {
      fireAnalytics("Network", "Connection Online");
      if (this.props.hasSubscription) {
        this.setArtworkInterval(this.artworkInterval);
        this.fetchMobilePlaylistInterval = setInterval(() => this.FetchFromMobile(), 5000);
      }
      else {
        this.setArtworkInterval(this.artworkInterval);
      }
      this.artworkErrorMessage = "Connection Online";
      this.setState({ artworkError: true });
      setTimeout(() => {
        this.setState({ artworkError: false });
      }, 3000);
    }
  }

  hideCollections() {
    this.setState(() => ({ hideCollection: true }));
  }

  setArtworkInterval(interval) {
    if (this.props.setting.switchArtwork) {
      if (interval === 0) {
        this.artworkInterval = interval;
        clearInterval(this.artworkIntervalTime);
      } else {
        clearInterval(this.artworkIntervalTime);
        this.artworkInterval = interval;
        this.artworkIntervalTime = setInterval(() => {
          this.k = 1;
          setTimeout(() => {
            this.nextHandle();
          }, 800);
        }, this.artworkInterval);
      }
    }
  }

  async FetchFromMobile() {
    try {
      if (this.props.hasSubscription) {
        const status = await this.props.fetchMobileStatus(this.props.device.data.uid);
        if (status.type === FETCH_MOBILE_STATUS_FAILURE) {
          if (status.errors === 'Device Unregistered') {
            this.props.history.push('/');
            return;
          }
        }
        if (this.state.lastMobileUpdate === null) {
          this.setState({ lastMobileUpdate: status.payload.queueUpdatedAt });
        }
        if (this.artworkInterval !== status.payload.interval) {
          this.setArtworkInterval(status.payload.interval);
        }
        if (this.state.qr !== status.payload.qr) {
          this.setState({ qr: status.payload.qr });
          this.props.updateQR(status.payload.qr);
        }
        if (status.payload.details) {
          // console.log("%cDetails", "color:green;font-weight:bold;font-size:14px");
          this.setState({ hideDetails: true });
          this.props.updateShowArtDetails(true);
        } else {
          // console.log("%cDetails", "color:red;font-weight:bold;font-size:14px");
          this.setState({ hideDetails: false });
          this.props.updateShowArtDetails(false);
        }
        if (this.state.quality !== status.payload.highQuality) {
          this.setState({ quality: status.payload.highQuality });
          this.props.updateQuality(status.payload.highQuality);
        }
        if (this.state.logo !== status.payload.logo) {
          this.setState({ logo: status.payload.logo });
          this.props.updateShowLogo(status.payload.logo);
        }
        if (this.state.mute !== status.payload.mute) {
          this.setState({ mute: status.payload.mute });
          this.props.updateMute(status.payload.mute);
        }
        if (this.state.lastMobileUpdate !== status.payload.queueUpdatedAt) {
          const result = await this.props.fetchMobileQueue(this.props.device.data.uid);
          if (result.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          if (result.errors === 'Device Unregistered') {
            this.props.history.push('/');
            return;
          }
          if (result.type === 'FETCH_MOBILE_QUEUE_SUCCESS') {
            this.setState({ lastMobileUpdate: status.payload.queueUpdatedAt });
            if (this.props.app.mobileId.localeCompare(status.payload.userId) !== 0) {
              this.props.history.push('/');
              return;
            }
            // if(this.props.hasSubscription.errors.length === 0) {
            //   this.artworkErrorMessage = 'Invalid Subscription';
            //   this.setState({ artworkError: true });
            //   setTimeout(() => {
            //     this.setState({ artworkError: false });
            //   }, 3000);
            //   return;
            // }
            // this.props.updateQuality(status.payload.highQuality);
            // this.props.updateMute(status.payload.mute);
            // this.props.updateQR(status.payload.qr);
            if (result.payload.collection.artwork.length <= 0) {
              this.artworkErrorMessage = 'Unable to play the Selected Artwork.';
              this.setState({ artworkError: true });
              setTimeout(() => {
                this.setState({ artworkError: false });
              }, 3000);
              return;
            }
            this.setState({
              artworks: result.payload.collection.artwork,
              current: 0,
            });
            this.setState({ activeComponent: false });
            clearInterval(this.artworkIntervalTime);
            this.artworkInterval = null;
            this.updatePlaylist = false;
            const activePlaylist = this.props.fetchActivePlaylist(result.payload.collection.id);
            if (activePlaylist.errors === 'Error') {
              setTimeout(() => {
                this.props.history.push('/error');
              }, 10);
              return;
            }
            fireAnalytics('Playlist', 'Playlist Received From Mobile', result.payload.collection.id);
          }
        }
      }
    } catch (err) {
      // console.log(err);
    }
  }

  async getArtworkFromPlaylist(id) {
    if (this.props.hasSubscription) {
      this.updatePlaylist = false;
      let activePlaylist = await this.props.fetchActivePlaylist(id);
      if (activePlaylist.errors === 'No Artworks') {
        this.artworkErrorMessage = 'No artworks in Collection';
        this.setState({ activeComponent: false, artworkError: true });
        setTimeout(() => {
          this.setState({ artworkError: false });
        }, 4000);
        await this.props.fetchActivePlaylist(this.prevPlaylistId);
      } else if (activePlaylist.errors === 'Error') {
        setTimeout(() => {
          this.props.history.push('/error');
        }, 10);
        return;
      } else {
        const body = {
          playlistId: id,
          artworkId: activePlaylist.payload.artwork[0].id,
          deviceIds: [`${this.props.device.data.id}`]
        }
        const response = await bdReq.post(`/users/${this.props.device.data.userId}/devices/play`, body);
        // const updatePlaylistNew = await this.props.fetchUpdatePlaylist(this.props.device.data.userId, body);
        // console.log("%cupdate playlist:", "color:green;font-size:20px", updatePlaylistNew);
        // let activePlaylist = await this.props.fetchActivePlaylist(id);
        // if (activePlaylist.errors === 'No Artworks') {
        //   this.artworkErrorMessage = 'No artworks in Collection';
        //   this.setState({ activeComponent: false, artworkError: true });
        //   setTimeout(() => {
        //     this.setState({ artworkError: false });
        //   }, 4000);
        //   await this.props.fetchActivePlaylist(this.prevPlaylistId);
        // } else if (activePlaylist.errors === 'Error') {
        //   setTimeout(() => {
        //     this.props.history.push('/error');
        //   }, 10);
        //   return;
        // } else {
        if (response.success) {
          this.setState({ activeComponent: false });
          if (response.body[0].queue.artworks.length <= 0) {
            this.artworkErrorMessage = 'No artworks in Collection';
            this.setState({ artworkError: true });
            setTimeout(() => {
              this.setState({ artworkError: false });
            }, 4000);
          } else {
            this.updatePlaylist = true;
          }
        }
      }
      fireAnalytics('Playlist', 'Playlist Changed', id);
    } else {
      localStorage.setItem('playlistID', id);
      this.props.history.push('/Pair');
    }
  }

  async addIdIntoDB(id) {
    let db;
    db = await idb.openDb('playlistIdDb', 1, (db) => {
      db.createObjectStore('playlistId', { keyPath: 'id' });
    });
    let tx = db.transaction('playlistId', 'readwrite');

    try {
      await tx.objectStore('playlistId').clear();
      await tx.objectStore('playlistId').add({ id });
    } catch (err) {
      if (err.name == 'ConstraintError') {
        alert('Such book exists already');
      } else {
        throw err;
      }
    }
  }

  async setCurrent(pid) {
    this.props.homePlaylist.data.filter((data, idx) => {
      if (data.playlistId === pid) {
        this.setState({ currentPlaylist: idx });
        return;
      }
    });
  }

  async setExitApp() {
    this.setState({ activeComponent: false });
  }

  prevHandle() {
    clearInterval(this.artworkIntervalTime);
    if (this.props.hasSubscription) {
      this.setArtworkInterval(this.props.device.data.interval);
    } else {
      this.setArtworkInterval(this.artworkInterval);
    }
    clearTimeout(this.state.navTimeout);
    const slides = this.state.artworks.slice(0);
    slides.unshift(slides.pop());

    const navTimeout = setTimeout(() => {
      this.setState((prevState) => ({ ...prevState, navigating: false }));
    }, 4000);

    this.setState((prevState) => ({
      ...prevState,
      navTimeout,
      artworks: slides,
    }));

    if (!this.props.setting.showArtworkDetails) {
      setTimeout(() => {
        this.setState({
          hideDetails: true,
        });
      }, 5000);
    } else {
      this.setState({
        hideDetails: false,
      });
    }
  }

  nextHandle = () => {
    clearInterval(this.artworkIntervalTime);
    if (this.props.hasSubscription) {
      this.setArtworkInterval(this.props.device.data.interval);
    } else {
      this.setArtworkInterval(this.artworkInterval);
    }
    clearTimeout(this.state.navTimeout);
    const newArray = this.state.artworks.slice(0);
    newArray.push(newArray.shift());
    const navTimeout = setTimeout(() => {
      this.setState((prevState) => ({ ...prevState, navigating: false }));
    }, 4000);
    this.setState((prevState) => ({ ...prevState, navTimeout, artworks: newArray }));

    if (!this.props.setting.showArtworkDetails) {
      setTimeout(() => {
        this.setState({
          hideDetails: true,
        });
      }, 5000);
    } else {
      this.setState({
        hideDetails: false,
      });
    }
  }

  getCurrentArtworkName() {
    const { artworks } = this.state;
    if (!artworks || artworks.length == 0) return '';

    return artworks[this.state.current].name;
  }

  getCurrentArtworkArtistName() {
    const { artworks } = this.state;
    if (!artworks || artworks.length == 0) return '';

    const { current } = this.state;
    if (artworks[current]?._embedded?.artist?.givenName && artworks[current]?._embedded?.artist?.surname)
      return `${artworks[current]?._embedded?.artist?.givenName} ${artworks[current]?._embedded?.artist?.surname}`;
    else if (artworks[current]?.artist?.displayName) return `${artworks[current]?.artist?.displayName}`;
    else return '';
  }

  componentWillUnmount() {
    clearInterval(this.fetchMobilePlaylistInterval);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedPlaylistId !== this.state.selectedPlaylistId && this.updatePlaylist) {
      this.prevPlaylistId = nextProps.selectedPlaylistId;
      const { artworks } = nextProps;
      this.setState({
        artworks,
        current: 0,
        selectedPlaylistId: nextProps.selectedPlaylistId,
      });
      clearInterval(this.artworkIntervalTime);
      this.setArtworkInterval(this.props.device.data.interval);
      this.setState({ activeComponent: false });
    }
    this.hideCollections();

    if (!nextProps.setting.showArtworkDetails) {
      this.setState({
        hideDetails: true,
      });
    } else {
      this.setState({
        hideDetails: false,
      });
    }
  }

  handleSoundCloudButtonClick(event) {
    if (event.keyCode === 13) {
      if (this.props.soundCloud.isStreaming) {
        this.props.pauseSoundCloudStream();
      } else {
        this.props.resumeSoundCloudStream();
      }
    }
    if (event.keyCode === 39 || event.keyCode === 37) {
      this.refs.home.focus();
    }
    if (event.keyCode === 40) {
      this.refs.previous.focus();
    }
  }

  handleCloseAccount() {
    this.setState({
      openAccount: false,
      openMenu: false,
    });
  }

  handleCloseSettings() {
    this.setState({
      openSettings: false,
      openMenu: false,
    });
  }

  render() {
    const { current, showNav, artworks } = this.state;
    const slideWidth = 100;
    let left = -current * slideWidth - 100;
    const slides = artworks.map((item, idx) => {
      left += slideWidth;
      if (idx === current) {
        return (
          <div key={idx} className="freemium-full-screen-carousel__slide" style={{ left: `${left}%` }}>
            <Artwork
              isCurrent={idx == current}
              artwork={item}
              hasSubscription={this.props.hasSubscription}
              history={this.props.history}
              nextHandle={this.nextHandle}
            />
          </div>
        );
      }
    });

    return (
      <div className="fullscreenFreemiumWrapper" ref="mainDiv">
        {slides}
        {this.state.open ? (
          <div id="models" className="reg-response-modal" style={{ position: 'absolute', zIndex: '9999' }}>
            <div
              className="model"
              style={{ width: '40%', backgroundColor: 'black', color: 'white', borderRadius: '15px' }}
            >
              <img
                className="Logo2"
                src="assets/img/blackdove-logo-2020.png"
                alt=""
                style={{ width: '50%', paddingTop: '6%' }}
              />
              <h2 style={{ marginBottom: '2%' }}>Do you want to exit?</h2>
              <button
                ref="no"
                id="No"
                style={{
                  padding: '2%',
                  float: 'left',
                  width: '30%',
                  fontSize: '2em',
                  marginBottom: '6%',
                  marginLeft: '14%',
                  marginTop: '4%',
                  fontWeight: '600',
                  background: '#910048',
                }}
              >
                No
              </button>
              <button
                ref="yes"
                id="yes"
                style={{
                  padding: '2%',
                  float: 'right',
                  width: '30%',
                  fontSize: '2em',
                  marginBottom: '6%',
                  marginRight: '18%',
                  marginTop: '4%',
                  fontWeight: '600',
                }}
              >
                Yes
              </button>
            </div>
          </div>
        ) : null}
        {this.state.clearCache ? (
          <div id="models" className="reg-response-modal" style={{ position: 'absolute', zIndex: '9999' }}>
            <div
              className="model"
              style={{ width: '40%', backgroundColor: 'black', color: 'white', borderRadius: '15px' }}
            >
              <img
                className="Logo2"
                src="assets/img/blackdove-logo-2020.png"
                alt=""
                style={{ width: '50%', paddingTop: '6%' }}
              />
              <h2 style={{ marginBottom: '2%', fontSize: '2em', padding: '0 1em' }}>
                Do you want to clear device cache and reload app?
              </h2>
              <button
                ref="no"
                id="No"
                style={{
                  padding: '2%',
                  float: 'left',
                  width: '30%',
                  fontSize: '2em',
                  marginBottom: '6%',
                  marginLeft: '14%',
                  marginTop: '4%',
                  fontWeight: '600',
                  background: '#910048',
                }}
              >
                No
              </button>
              <button
                ref="yes"
                id="yes"
                style={{
                  padding: '2%',
                  float: 'right',
                  width: '30%',
                  fontSize: '2em',
                  marginBottom: '6%',
                  marginRight: '18%',
                  marginTop: '4%',
                  fontWeight: '600',
                }}
              >
                Yes
              </button>
            </div>
          </div>
        ) : null}

        {this.state.openMenu ? (
          <div className="topMenu">
            <button className={`topMenu__item ${this.state.selectedMenu === 'account' && 'selectedMenuItem'}`}>
              <img className="topMenu__item__icon" src="assets/img/account.svg" alt="" />
              <p className="topMenu__item__txt">Account</p>
            </button>
            <button className={`topMenu__item ${this.state.selectedMenu === 'settings' && 'selectedMenuItem'}`}>
              <img className="topMenu__item__icon" src="assets/img/settings.svg" alt="" />
              <p className="topMenu__item__txt">Settings</p>
            </button>
          </div>
        ) : null}

        {this.props.setting.showLogo && <img className="player-logo" src="assets/img/blackdove-logo-2020.png" alt="" />}
        {((this.state.qr && artworks[this.state.current].qrTrackableUrl) || !this.state.hideDetails) && <div className="detail_container" style={{ paddingLeft: '1%' }}>
          {!this.state.hideDetails && (
            <div
              className="detailsContainer"
              style={{
                padding: window.innerWidth <= window.innerHeight ? '3rem 60px 2rem 30px' : '0.7rem 60px 1.7rem 30px',
                right: this.state.qr && artworks[this.state.current].qrTrackableUrl ? '4%' : '1%'
              }}
            >
              {/* <div> */}
              <p
                className="h--no-spacing"
                style={{
                  color: 'white',
                  textTransform: 'uppercase',
                  fontSize: window.innerWidth <= window.innerHeight ? '2.4rem' : '1.8rem',
                  fontStyle: 'normal',
                  fontWeight: '600',
                  letterSpacing: '0em',
                  textAlign: 'left',
                  lineHeight: '2rem',
                  marginBottom: window.innerWidth <= window.innerHeight ? '2.4rem' : '1.4rem',
                  whiteSpace: 'nowrap',
                }}
              >
                {this.getCurrentArtworkName()}
              </p>
              <p
                className="h--normalize-weight"
                style={{
                  color: 'white',
                  fontSize: window.innerWidth <= window.innerHeight ? '1.8rem' : '1.5rem',
                  marginBottom: '0.2rem',
                  whiteSpace: 'nowrap',
                }}
              >
                {this.getCurrentArtworkArtistName()}
              </p>
              {/* </div> */}

            </div>
          )}

          {this.state.qr && artworks[this.state.current].qrTrackableUrl &&
            <div className='QRCodeF'>
              <QR
                className=""
                value={artworks[this.state.current].qrTrackableUrl}
                size={window.innerWidth <= window.innerHeight ? 80 : 80}
                renderAs="svg"
                style={{
                  border: '6px solid white',
                  borderRadius: '12px'
                }}
              />
            </div>
          }
        </div>}

        {this.state.navigating && (
          <div className="fullscreenNavOverlay">
            <div
              onClick={() => {
                this.prevHandle();
              }}
              className="btn btn--circle navLeft"
            >
              <span tabIndex="2" ref="previous" className="ion-ios-arrow-back btn--arrow" />
            </div>
            <div>
              <p
                className="h--no-spacing"
                style={{
                  color: 'white',
                  textTransform: 'uppercase',
                  fontSize: window.innerWidth <= window.innerHeight ? '2.4rem' : '1.8rem',
                  fontStyle: 'normal',
                  fontWeight: '600',
                  letterSpacing: '0em',
                  textAlign: 'left',
                  lineHeight: '3rem',
                  marginBottom: window.innerWidth <= window.innerHeight ? '2.4rem' : '1.4rem',
                }}
              >
                {this.getCurrentArtworkName()}
              </p>
              <p
                className="h--normalize-weight"
                style={{
                  color: 'white',
                  fontSize: window.innerWidth <= window.innerHeight ? '1.8rem' : '1.5rem',
                  marginBottom: 0,
                  textAlign: 'center',
                }}
              >
                {this.getCurrentArtworkArtistName()}
              </p>
            </div>
            <div
              onClick={() => {
                this.nextHandle();
                this.k = 1;
              }}
              className="btn btn--circle navRight"
            >
              <span ref="next" tabIndex="3" className="ion-ios-arrow-forward btn--arrow" />
            </div>
          </div>
        )}

        <div className="artworkError" style={!this.state.artworkError ? { opacity: '0' } : { opacity: '1' }}>
          {this.artworkErrorMessage}
        </div>
        <div className="userAgent" id="userAgent"></div>
        <div className="deviceDetails" id="deviceDetails"></div>
        {this.state.activeComponent ? (
          <div className="PlaylistSelector" style={this.state.activeComponent ? { bottom: '0%' } : { bottom: '-36%' }}>
            <SelectedPlaylistCarousel
              ref="playlistChild"
              playlist={this.props.homePlaylist.data}
              myPlaylist={this.props.myPlaylist}
              currentPlaylist={this.state.currentPlaylist}
              subscription={this.props.hasSubscription}
              history={this.props.history}
              dispatch={this.props.dispatch}
              getArtworkFromPlaylist={(pid) => this.getArtworkFromPlaylist(pid)}
              setCurrent={(pid) => this.setCurrent(pid)}
              onExitApp={() => this.setExitApp()}
              hideCollections={this.hideCollections}
            />
          </div>
        ) : null}

        {this.state.openAccount ? (
          <Account onClose={() => this.handleCloseAccount()} history={this.props.history} />
        ) : null}

        {this.state.openSettings ? <Settings onClose={() => this.handleCloseSettings()} /> : null}

        <SoundCloudPlayer />
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  fetchActivePlaylist: (targetPlaylistId) => dispatch(fetchActivePlaylist(targetPlaylistId)),
  fetchMobileQueue: (deviceId) => dispatch(fetchMobileQueue(deviceId)),
  fetchMobileStatus: (deviceId) => dispatch(fetchMobileStatus(deviceId)),
  pauseSoundCloudStream: () => dispatch(pauseSoundCloudStream()),
  resumeSoundCloudStream: () => dispatch(resumeSoundCloudStream()),
  updateMute: (val) => dispatch(setMute(val)),
  updateShowLogo: (val) => dispatch(setShowLogo(val)),
  updateShowArtDetails: (val) => dispatch(setShowArtworkDetails(val)),
  updateQR: (val) => dispatch(setQR(val)),
  updateSwitchArtwork: (val) => dispatch(setSwitchArtwork(val)),
  updateQuality: (val) => dispatch(set4kQuality(val)),
});

export default connect((state) => {
  const { homePlaylist, userPlaylists, myPlaylist, device, mobileQueue, soundCloud, app, setting } = state;
  return {
    app,
    userPlaylists,
    homePlaylist,
    myPlaylist,
    device,
    mobileQueue,
    soundCloud,
    setting,
  };
}, mapDispatchToProps)(FreemiumCarousel);
